import { Asset } from '../..';
import { fixedIncomeOffersQueryUpdated } from '../../../../../../../../store/product/selectors';

import { FixedIncomeListItem } from './ListItem';
import { ListLoadingItem } from './ListLoadingItem';

export const FixedIncomeAsset = () => {
  return (
    <Asset
      productsQuery={fixedIncomeOffersQueryUpdated}
      ProductItem={FixedIncomeListItem}
      ProductItemLoading={ListLoadingItem}
      keySelector="productIdNormalized"
    />
  );
};
